<template>
  <svg class="icon" :class="{ 'icon-spin': spin }" v-bind="attrs" v-on="listeners">
    <title v-if="title !== ''">{{ title }}</title>
    <use :xlink:href="`#${icon}`" />
  </svg>
</template>

<script>
export default {
  name: 'VpIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    spin: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  computed: {
    listeners() {
      return this.$listeners;
    },
    attrs() {
      const { type, ...attrs } = this.$attrs;
      return attrs;
    },
  },
};
</script>

<style lang="scss" scoped>
  svg {
    &.icon {
      width: 1em;
      height: 1em;
      vertical-align: middle;
      margin-bottom: 0.125em;
      fill: currentColor;
    }
    &.icon-spin {
      animation: icon-spin 2s infinite linear;
    }
  }

  @keyframes icon-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
</style>
